// extracted by mini-css-extract-plugin
export default {"verizonNavBar":"Verizon_verizonNavBar__D+SV9"};